export default __webpack_public_path__ + "static/media/blindsGarageDown.665401c7.gif";